import type { GetFeaturesInnerParams } from '@/app/components/search/components/Card/Details/Features/getFeatures/types.ts';
import { type Feature, FeatureType } from '@/app/components/search/components/Card/utils/facilitiesTypes.ts';

export const getSoldOutFeatures = ({ t, hasAlternativeDates, isOverlay }: GetFeaturesInnerParams): Feature[] => [
  {
    icon: { category: 'Semantics', name: 'icon-circle-solid-warning', color: 'iconError' } as const,
    text: t('vacation.oss.cards.not_available_dates'),
    className: 'not-available',
    featureType: FeatureType.danger,
  },
  ...(hasAlternativeDates && !isOverlay
    ? [
        {
          icon: ``,
          text: t('vacation.oss.cards.available_dates'),
          className: 'alternative-dates',
          featureType: FeatureType.normal,
        },
      ]
    : []),
];
